import {
  seoSegmentationListingPage_seoSegmentationSearchResults_SEOSegmentationSearchResultsSuccess_caregiverSearchResults_latestReview as LatestCargiverReviewType,
  seoSegmentationListingPage_seoSegmentationSearchResults_SEOSegmentationSearchResultsSuccess_providerSearchResults_latestReview as LatestProviderReviewType,
} from '@/__generated__/seoSegmentationListingPage';
import { ReadMore } from '@/components/common/ReadMore';
import { AmplitudeEvent, trackAmplitudeEvent } from '@/lib/analyticsHelper';

export interface LatestReviewProps {
  latestReview: NonNullable<LatestCargiverReviewType | LatestProviderReviewType>;
}

export const LatestReview = ({ latestReview }: LatestReviewProps) => {
  const handleReviewShowMoreClick = () => {
    trackAmplitudeEvent(AmplitudeEvent.seoFeatureInteracted, {
      feature_name: 'Show More Review Content',
    });
  };
  return (
    <ReadMore
      variant="body3"
      color="text.secondary"
      charLimit={170}
      showMoreLabel="read more"
      value={`${latestReview.reviewer.displayName || 'Care Member'} says "${latestReview.comment}"`}
      onClick={handleReviewShowMoreClick}
    />
  );
};
